import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CampaignsService } from 'src/app/pages/campaign-module/campaigns/campaigns.service';
import { debounceTime, filter, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { DialogService, LanguageService, HelperService } from 'src/app/services';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'esc-web-user-selector',
  templateUrl: './web-user-selector.component.html',
  styleUrls: ['./web-user-selector.component.scss']
})
export class WebUserSelectorComponent implements OnInit {
  @Input() textLabel;
  @Input() wrapperLayoutAlign;
  @Input() labelFlex;
  @Input() formWrapperFlex;
  @Input() selectedWebUser;
  @Input() selectedCampaign;
  @Output() webUserSelected = new EventEmitter;
  
  form: FormGroup;
  originals = [];
  loading = {
    webUser: false,
    init: false,
    more: false,
    error: false
  };
  public listData = [];
  private currentFilters;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  constructor(
    private fb: FormBuilder,
    private helper: HelperService,
    public campSvc: CampaignsService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    ) { }

  ngOnInit() {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    this.initForm();
    this.detectFormChanges();
  }

  ngOnDestroy() {}

  initForm() {
    this.form = this.fb.group({
      webUser: [null, [Validators.required, this.helper.checkIfObject]]
    })

    if(this.selectedWebUser) {
      this.form.get('webUser').setValue(this.selectedWebUser);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.currentFilters = _.cloneDeep(INITIAL_OPTIONS);
    if(changes && changes.selectedWebUser && !changes.selectedWebUser.firstChange) {
      this.form.get('webUser').setValue(changes.selectedWebUser.currentValue, { emitEvent : false });
    }
    
    if(changes && changes.selectedCampaign && changes.selectedCampaign.currentValue) {
      this.currentFilters.web_filter.distribution_id = _.get(changes.selectedCampaign.currentValue,'distribution_id') || 0;
    }
  }

  detectFormChanges() {
    this.form.get('webUser').valueChanges.pipe(
      debounceTime(600),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      this.currentFilters.web_filter.keyword = _.toString(value);
      this.listData = [];
      this.getListData();
    });
  }

  getInitialValues(data) {
    this.currentFilters.web_filter.offset = 0;
    this.currentFilters.web_filter.keyword = "";
    this.getListData();
  }

  getListData() {
    this.currentFilters.web_filter.distribution_id = _.get(this.selectedCampaign,'distribution_id') || 0;

    this.loading.webUser = true;
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }

    this.campSvc.getUserRecipientGroups(this.currentFilters)
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        this.loading.webUser = false;
        this.loading.init = false;
        this.loading.more = false;
        if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
          this.loading.error = true;
          this.listData = [];
          this.dialogService.openSnackBar(this.networkErrMsg)
          return;
        }
        if (_.has(res, 'value') && (res.value == "Success")) {
          this.listData = this.listData.concat(res.data);
        } else {
          this.listData = [];
        }
      }, err => {
        if (environment.showLogs) {
          console.error(err);
        }
        this.loading.webUser = false;
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.limit -= this.currentFilters.web_filter.offset;
        }
        return observableOf(null);
      });
  }

  displayFn(data?: any): string | undefined {
    if(data) {
      return _.get(data, 'username');
    }
    return null;
  }

  autoCmpltClosed() {
    this.listData = [];

    if (_.has(this.form.get('webUser'), 'value') && _.isObject(_.get(this.form.get('webUser'), 'value'))) {
      this.webUserSelected.next(_.get(this.form.get('webUser'), 'value'));
    }
  }

  clearForm(ev: Event) {
    this.listData = [];
    this.form.get('webUser').setValue(null, {emitEvent: false});
    this.webUserSelected.next(null);
    ev.stopPropagation();
  }
}

const INITIAL_OPTIONS = {
  web_filter: {
    offset: 0,
    limit: 50,
    keyword: "",
    is_asc: 1,
    distribution_id: 0,
    getMore: true
  }
}